var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleFillCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00118 5.7581C7.79878 5.7581 7.62511 5.69098 7.48025 5.55675C7.33745 5.42039 7.26611 5.25739 7.26611 5.06776C7.26611 4.88026 7.33745 4.7194 7.48025 4.58516C7.62511 4.4488 7.79878 4.38062 8.00118 4.38062C8.20358 4.38062 8.37618 4.4488 8.51891 4.58516C8.66385 4.7194 8.73625 4.88026 8.73625 5.06776C8.73625 5.25739 8.66385 5.42039 8.51891 5.55675C8.37618 5.69098 8.20358 5.7581 8.00118 5.7581Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31738 6.72437V11.3001H8.67885V6.72437H7.31738Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992ZM13.3333 7.99992C13.3333 10.9455 10.9455 13.3333 7.99992 13.3333C5.0544 13.3333 2.66659 10.9455 2.66659 7.99992C2.66659 5.0544 5.0544 2.66659 7.99992 2.66659C10.9455 2.66659 13.3333 5.0544 13.3333 7.99992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleFillCurrent);
export default __webpack_public_path__ + "static/media/infoCircleFillCurrent.9b40f7c0bf8e44be9b504e2389620f9e.svg";
export { ForwardRef as ReactComponent };